<template>
  <div>
    <nuxt-child />
    <the-entry :data="entry" gray />
  </div>
</template>

<script>
import TheEntry from '@/components/TheEntry'

export default {
  components: { TheEntry },
  data() {
    return {
      entry: ['join', 'about', 'game', 'business'],
    }
  },
}
</script>
